import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@mui/material/Typography';
import { EScheduleSteps, updateScheduleSteps } from '../../../../features/schedule/schedule-slice';
import Box from '@mui/material/Box';

import { RootState } from '../../../../store';
import Modal from '../../Modal/ModalBasic';
import { ButtonCustom } from '../../JourneyActionManager/AwaitingScheduleReturn/ChooseReturnType/styled';
import {
  clearCalendarSelected,
  prepareToCalendarSelected,
  saveCalendarSelected,
  saveTypeOfAppointment,
  TypeOfAppointment
} from '../../../../features/calendar/calendar-slice';

interface ISelectAvailableTimes {
  open: boolean;
  onFinished: () => void;
}

const ReturnAppointment = ({ open, onFinished }: ISelectAvailableTimes) => {
  const dispatch = useDispatch();
  const {
    calendar: { calendarsAvailables, isReSchedule }
  } = useSelector((state: RootState) => state);
  const virtualCalendars = calendarsAvailables?.filter(calendar => calendar.type === 'VIRTUAL_CONSULTATION');
  const physicalCalendars = calendarsAvailables?.filter(calendar => calendar.type === 'PHYSICAL_APPOINTMENT');

  const handleOnClick = (typeOfAppointment: TypeOfAppointment) => {
    dispatch(saveTypeOfAppointment({ typeOfAppointment }));
    onFinished();
  };

  const PhysicalCalendarsAvailableList =
    physicalCalendars.length > 0 ? (
      <>
        <Box mb={1} mt={1}>
          <ButtonCustom
            onClick={() => {
              if (physicalCalendars.length === 1) {
                dispatch(saveCalendarSelected({ calendar: physicalCalendars[0] }));
              }
              handleOnClick(TypeOfAppointment.PHYSICAL_APPOINTMENT);
            }}
          >
            <Typography variant="body2B">Consulta Presencial em São Paulo</Typography>
          </ButtonCustom>
        </Box>
      </>
    ) : (
      []
    );

  const VirtualCalendarsAvailableList = (
    <Box mb={1} mt={1}>
      <ButtonCustom
        onClick={() => {
          dispatch(saveCalendarSelected({ calendar: virtualCalendars[0] }));
          handleOnClick(TypeOfAppointment.VIRTUAL_CONSULTATION);
        }}
      >
        <Typography variant="body2B">Consulta Online</Typography>
      </ButtonCustom>
    </Box>
  );

  useEffect(() => {
    if (calendarsAvailables.length > 1) dispatch(prepareToCalendarSelected({ isReSchedule: isReSchedule }));
  }, []);

  return (
    <Modal
      open={open}
      onCloseHandler={() => {
        dispatch(updateScheduleSteps({ currentStep: EScheduleSteps.idle, previousStep: EScheduleSteps.idle }));
        dispatch(clearCalendarSelected());
      }}
      title={'Agendar retorno'}
      typeTitle="h3"
    >
      <Typography>Como você gostaria de realizar seu retorno?</Typography>
      {PhysicalCalendarsAvailableList}
      {VirtualCalendarsAvailableList}
    </Modal>
  );
};

export default ReturnAppointment;
